module.exports = __webpack_public_path__ + "img/puppy-ready.51119953.png";